import PropTypes from 'prop-types';

import { trans, useSoyuzClientConfig } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';

import {
  getStaticMapUrl,
  getStaticMapUrlMapbox
} from '@spotahome/marketplace-common/src/utils/static-map';

import './MapPlaceholder.scss';

const MapPlaceholder = ({
  city,
  cityCenterCoords,
  onButtonClick,
  mapProviderVariant
}) => {
  const { defaultZoom, mapboxAccessToken, googleMapsApiKey } =
    useSoyuzClientConfig();
  const cityZoom = defaultZoom[city];

  const src =
    mapProviderVariant === 'mapbox'
      ? getStaticMapUrlMapbox({
          lat: cityCenterCoords.lat,
          lng: cityCenterCoords.lng,
          zoom: cityZoom,
          accessToken: mapboxAccessToken
        })
      : getStaticMapUrl({
          lat: cityCenterCoords.lat,
          lng: cityCenterCoords.lng,
          zoom: cityZoom,
          apiKey: googleMapsApiKey
        });

  return (
    <div className="map-placeholder">
      <img
        className="map-placeholder__image map-placeholder__image--blur"
        src={src}
        alt="map placeholder"
      />

      <Button
        onClick={onButtonClick}
        color="secondary"
        data-test="search-map-activation"
      >
        {trans('map.lazy.cta.text')}
      </Button>
    </div>
  );
};

MapPlaceholder.propTypes = {
  city: PropTypes.string.isRequired,
  cityCenterCoords: PropTypes.shape({
    lat: PropTypes.string,
    lng: PropTypes.string
  }).isRequired,
  onButtonClick: PropTypes.func.isRequired,
  mapProviderVariant: PropTypes.string
};

export default MapPlaceholder;
